// BASE URL's
export const rootUrl = `${process.env.REACT_APP_ORIGIN}irost-data-service/${process.env.REACT_APP_PERSON_API_VERSION}`;
export const protocolUrl = `${process.env.REACT_APP_ORIGIN}protocol-data-service/${process.env.REACT_APP_PERSON_API_VERSION}`;
export const esysDataServiceUrl = `${process.env.REACT_APP_ORIGIN}esys-data-service/${process.env.REACT_APP_PERSON_API_VERSION}`;
export const personDataServiceUrl = `${process.env.REACT_APP_ORIGIN}person-data-service/${process.env.REACT_APP_PERSON_API_VERSION}`;
export const pRostDataServiceUrl = `${process.env.REACT_APP_ORIGIN}prost-data-service/${process.env.REACT_APP_PERSON_API_VERSION}`;
export const siteDataServiceUrl = `${process.env.REACT_APP_ORIGIN}site-data-service/${process.env.REACT_APP_PERSON_API_VERSION}`;
export const userDataServiceUrl = `${process.env.REACT_APP_ORIGIN}core-service/${process.env.REACT_APP_PERSON_API_VERSION}/core/value/job`;
export const personAutoComplete = `${process.env.REACT_APP_ORIGIN}person-data-service/v1/persons/autocomplete`;

// END URL's
export const sitesUrlBase = `${rootUrl}/rosters/sites`;
export const sitesUrl = `${rootUrl}/sites/number`;
export const rosterUrl = `${rootUrl}/rosters`;
export const rosterNumUrl = `${rosterUrl}/number`;
export const scheduleAaffiliationsUrl = `${rootUrl}/sites/schedule/affiliations`;
export const affiliationsJobUrl = `${rootUrl}/rosters/affiliations/job`;

export const sitesDataServiceCore = `${siteDataServiceUrl}/sites`;
export const sitesDataService = `${sitesDataServiceCore}/number`;
export const instSearchURL = `${sitesDataServiceCore}/search`;
export const personSearchUrl = `${personDataServiceUrl}/persons`;
export const pRostPersonUrl = `${pRostDataServiceUrl}/persons`;
export const personBrowserUrl = `${pRostDataServiceUrl}/rosters/browse`;
export const copyPersonsListUrl = (rosterId) => `${rosterUrl}/id/${rosterId}/copypersonslist`;

// credentialing details URL
export const personChangesUrl = (rusRequestId) => `${rootUrl}/rosters/id/${rusRequestId}/credential/personchanges`;
export const rolechangesUrl = (rusRequestId) => `${rootUrl}/rosters/id/${rusRequestId}/credential/rolechanges`;
export const packagechangesUrl = (rusRequestId) => `${rootUrl}/rosters/id/${rusRequestId}/credential/packagechanges`;
export const sitechangesUrl = (rusRequestId) => `${rootUrl}/rosters/id/${rusRequestId}/credential/sitechanges`;
export const addPersonUrl = (rusRequestId) => `${rootUrl}/rosters/credentials/${rusRequestId}/details`;
export const siteDetailUrl = (rusRequestId) => `${rootUrl}/rosters/id/${rusRequestId}/credential/sitedetails`;
export const ctsuUpdatePersonAttrDetailsUrl = (rusRequestId) => `${rootUrl}//rosters/credentials/${rusRequestId}/personattributerequestdetails`;
export const addRoleTnxUrl = (rusRequestId) => `${rootUrl}/rosters/id/${rusRequestId}/credential/rolechangestransaction`;

export const attributeTreeDropDownUrl = (ownerType, attributeClass) => `${rootUrl}/rosters/owner/${ownerType}/attribute/${attributeClass}`;
export const personAddressUrl = (ctepId, addressId) => `${personDataServiceUrl}/persons/id/${ctepId}/address/${addressId}`;
export const personContactUrl = (personId) => `${personDataServiceUrl}/persons/id/${personId}/contacts`;
export const ctepRosterFlagUrl = `${personDataServiceUrl}/persons/cteprosterflag`;
export const roleStatusUrl = `${personDataServiceUrl}/persons/roster/rolestatus`;

// sync with ctep
export const syncCtepDataUrl = (personId) => `${personDataServiceUrl}/persons/id/${personId}/syncctepdata `;

// person Role
export const rosterRolesRoleNames = (userGroup, role) => `${pRostPersonUrl}/${userGroup}/${role}/rosterrolesrolenames`;
export const rosterRolesSiteIds = (userGroup, ctsuId) => `${pRostPersonUrl}/${userGroup}/${ctsuId}/rosterrolessiteIds`;
export const rosterRolesRoleTypes = (userGroup) => `${pRostPersonUrl}/${userGroup}/rosterrolesroletypes`;
export const rosterRolesAssociation = `${pRostPersonUrl}/association`;
export const rosterRolesObjectTypes = `${pRostPersonUrl}/rosterrolesobjecttypes`;
export const saveRolesRecordUrl = `${personSearchUrl}/id/personrosterroles`;
export const saveMultiRolesRecordUrl = `${personSearchUrl}/id/personrosterroles/bulkupdate`;

export const getEventcauseflagUrl = (rosterGroup, roleId) => `${personDataServiceUrl}/persons/roster/${rosterGroup}/id/${roleId}/eventcauseflag`;